<!-- Dropdown menu -->
<div class="relative">
  <p-button #button (click)="toggle()" text severity="secondary">
    <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 4 15">
      <path
        d="M3.5 1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 6.041a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 5.959a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
      />
    </svg>
  </p-button>
  <div
    #dropdown
    [style.display]="open() ? 'block' : 'none'"
    class="z-10 absolute bg-white divide-y divide-gray-100 rounded-lg shadow-sm w-56"
  >
    <ng-content></ng-content>
  </div>
</div>
